import styled from "styled-components";

export const Container = styled.div`
	min-width: 400px;
	width: 100%;
`;

export const Title = styled.h2`
	font-weight: bold;
	font-size: 1.125rem;
	margin: 0 0 0.5rem;
	text-align: center;
`;

export const Subtitle = styled.p`
	font-size: 1rem;
	margin: 0 0 1.5rem;
	text-align: center;
`;

export const FieldWrapper = styled.div`
	border: 1px solid rgba(0, 0, 0, 0.23);
	padding: 0.1rem;
	border-radius: 10px;
`;

export const AreaFooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	justify-content: center;
	width: 100%;

	> button {
		margin: 0;
	}
`;
